module.exports = __webpack_public_path__ + "static/media/fixed_voice_dash_arrow_left_disabled.cadc48ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_dash_arrow_left_disabled.svg
// module id = 981
// module chunks = 0